import React, { useState, useEffect } from 'react' // eslint-disable-line
import { Box, Typography, SwxTheme } from 'swx-atomic-component-lib'
import ReCAPTCHA from 'react-google-recaptcha'
import ReactGA from 'react-ga'

import Username from './formComponents/username'
import Email from './formComponents/email'
import Phone from './formComponents/phone'
import Password from './formComponents/password/'
import i18n from '../../i18n'
import ButtonWithSpinner from '../utils/ButtonWithSpinner'

function SelfRegisterComponent (props) {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [password, setPassword] = useState('')
  const [passwordAgain, setPasswordAgain] = useState('')
  const [firstNameErr, setFirstNameErr] = useState(true)
  const [lastNameErr, setLastNameErr] = useState(true)
  const [emailErr, setEmailErr] = useState(true)
  const [phoneErr, setPhoneErr] = useState(false)
  const [passwordErr, setPasswordErr] = useState(true)
  const [passwordAgainErr, setPasswordAgainErr] = useState(true)
  const [canSignUp, setCanSignUp] = useState(false)
  const [captchaSuccess, setCaptchaSuccess] = useState(false)
  const [recaptcha, setRecaptcha] = useState('')

  const {
    submitForm,
    goToSignIn,
    loading,
    refreshCaptcha
  } = props

  const { x3 } = SwxTheme.sizing

  useEffect(() => {
    const formError = {
      email: emailErr,
      password: passwordErr,
      passwordAgain: passwordAgainErr,
      fname: firstNameErr,
      lname: lastNameErr,
      phone: phoneErr
    }
    const formStats = Object.values(formError)
    formStats.includes(true) ? setCanSignUp(false) : setCanSignUp(true)
  }, [firstNameErr, lastNameErr, emailErr, passwordErr, passwordAgainErr, phoneErr])

  function onSubmit (e, canSignUp) {
    if (canSignUp === false) {
      return
    }

    const formData = {
      firstName,
      lastName,
      email,
      phone,
      password,
      passwordAgain,
      recaptcha
    }

    ReactGA.event({ category: 'Register', action: 'Completed Register form' })

    submitForm(formData)
  }

  function onFnameChange (value, error) {
    setFirstName(value, error)
    setFirstNameErr(error)
  }

  function onLnameChange (value, error) {
    setLastName(value)
    setLastNameErr(error)
  }

  function onEmailChange (value, error) {
    setEmail(value)
    setEmailErr(error)
  }

  function onPhoneChange (value, error) {
    setPhone(value)
    setPhoneErr(error)
  }

  function onPasswordChange (value, error) {
    setPassword(value)
    setPasswordErr(error)
  }

  function onPasswordAgainChange (value, error) {
    setPasswordAgain(value)
    setPasswordAgainErr(error)
  }

  function onClickGoToSignIn () {
    goToSignIn()
  }

  function onChangeCaptcha (val) {
    setCaptchaSuccess(val && val.length > 0)
    setRecaptcha(val)
  }

  function onClickPrivacy () {
    window.open(process.env.REACT_APP_PRIVACY_POLICY_URL)
  }

  return (
    <Box onSubmit={(e) => e.preventDefault()}>
      <Box customStyle={greyBackground}>
        <Typography customStyle={formHeaderStyle} color='secondary-dark' className='mobile-input-margin' ellipsis={false}>
          <Box renderAs='span' customStyle={signUpTitleStyle}>
            {i18n.registerNewPage.title.locate}
          </Box>
        </Typography>
        <Username
          fnameValue={firstName}
          lnameValue={lastName}
          fnameChange={onFnameChange}
          lnameChange={onLnameChange}
        />
        <Email
          emailChange={onEmailChange}
          emailValue={email}
        />
        <Phone
          phoneChange={onPhoneChange}
          phoneValue={phone}
        />
        <Password
          passwordChange={onPasswordChange}
          passwordAgainChange={onPasswordAgainChange}
          passwordValue={password}
          passwordAgainValue={passwordAgain}
          minScore={3}
        />
      </Box>
      <Box display='flex' alignItems='center' mt={x3} customStyle={captchaContainer} className='mobile-zero-padding'>
        {!refreshCaptcha && (
          <ReCAPTCHA
            size='normal'
            sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
            onChange={onChangeCaptcha}
          />
        )}
      </Box>
      <Box display='flex' flexDirection='column' justifyContent='space-between' mt={24} pl={43} className='mobile-zero-padding'>
        <Box className='col-s-6 col-m-12 col-12'>
          <ButtonWithSpinner
            isLoading={loading}
            value={i18n.registerNewPage.button.default}
            disabled={(!canSignUp || !captchaSuccess)}
            onClick={e => onSubmit(e, canSignUp)}
            customStyle={buttonStyle}
          />
        </Box>
        <Box display='flex' mt={24}>
          <Typography size={13} variant='medium' color='primary' customStyle={`margin-left: ${x3}; cursor: pointer;`} onClick={onClickPrivacy}>{i18n.registerNewPage.footer.privacyLink}</Typography>
        </Box>
      </Box>
      <Box display='flex' flexDirection='column' justifyContent='space-between' mt={8} pl={43} customStyle={loginContainer} className='mobile-zero-padding mobile-row mobile-left-justify'>
        <Typography size={13}>{i18n.registerNewPage.footer.info}</Typography>
        <Typography size={13} variant='medium' color='primary' customStyle={goToSignInStyle} onClick={onClickGoToSignIn}>{i18n.registerNewPage.footer.gotoSignInlink}</Typography>
      </Box>
    </Box>
  )
}

const formHeaderStyle = `
  margin-bottom: 41px;
  font-size: 20px;
  margin-left: 46px;
`

const greyBackground = `
  @media only screen and (max-width: 600px) {
    padding: 24px 16px 24px 16px !important;
    background-color: ${SwxTheme.palette.g100};
  }
`
const signUpTitleStyle = `
  color: ${SwxTheme.palette.primary}
  font-size: 17px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
`
const goToSignInStyle = `
  padding-left: 24px;
  cursor: pointer
  @media only screen and (max-width: 600px) {
    padding: 0 0 0 8px !important;
  }
`
const captchaContainer = `
  @media only screen and (max-width: 600px) {
    justify-content: center;
  }
  @media only screen and (min-width: 600px) {
    padding: 8px !important;
    background-color: ${SwxTheme.palette.g200} !important;
    margin-left: 46px !important;
  }
`
const loginContainer = `
  @media only screen and (min-width: 600px) {
    position: relative !important;
    margin: 0 !important;
    top: -16px !important;
    flex-direction: row !important;
    justify-content: flex-start !important;
    left: 165px !important;
  }
`
const buttonStyle = `
  &:disabled { 
    background-color: #bed0e5; 
    opacity: 1; 
    border-color: #bed0e5 ;
  }
  @media only screen and (max-width: 600px) {
    width: 100% !important;
  }
  @media only screen and (min-width: 600px) {
    width: 100% !important;
  }
`

export default SelfRegisterComponent
